import Contact from "../pages/Contact";
import Danzuverse from "../pages/Danzuverse";
import Home from "../pages/Home";

export const pathsandelements = [

    {
        path: '/',
        element: <Home />
    },
    {
        path: '/contact',
        element: <Contact/>
    },
    {
        path: '/danzuverse',
        element: <Danzuverse/>
    },

]